import React from 'react';

import Launcher from '_modules/chat/components/launcher';
import Panel from '_modules/chat/components/panel';
import { useChatContext } from '_modules/chat/hooks/useContext';

import { StyledWidget } from './style';

const Widget = () => {
  const { state } = useChatContext();

  return <StyledWidget>{state.isOpen ? <Panel /> : <Launcher />}</StyledWidget>;
};

export default Widget;
